import { brandApi } from '../lib/axios';

export interface AmpedProfilePayload {
  firstName: string;
  lastName: string;
  email: string;
  phoneCountryCode: string;
  phoneNumber: string;
  instagramUsername?: string;
  twoFaEnabled: boolean;
  acceleratedPageGrowth: boolean;
  welcomeDmEnabled: boolean;
  aiTargeting: boolean;
  audienceTargeting?: string;
  keywordsHashtags?: string;
  competitorAccounts?: string;
}

export interface AmpedProfile extends AmpedProfilePayload {
  id: string;
  sessionId: string;
  createdAt: string;
  updatedAt: string;
}

export interface CurrentAmpedProfileResponse {
  profile: AmpedProfile | null;
  currentAmpedPlan: 'STARTER' | 'PRO' | 'ELITE' | null;
}

export interface AmpedPlanRecord {
  id: string;
  name: 'STARTER' | 'PRO' | 'ELITE';
  displayName: string;
  price: number;
  sortOrder: number;
  isActive: boolean;
}

class AmpedService {
  private static instance: AmpedService;

  private constructor() {}

  public static getInstance(): AmpedService {
    if (!AmpedService.instance) {
      AmpedService.instance = new AmpedService();
    }
    return AmpedService.instance;
  }

  async listPlans(): Promise<AmpedPlanRecord[]> {
    const { data } = await brandApi.get('/amped/plans');
    return data.plans;
  }

  async getProfile(): Promise<AmpedProfile | null> {
    try {
      const { data } = await brandApi.get('/amped/profile');
      return data.profile;
    } catch {
      return null;
    }
  }

  async getCurrentProfile(): Promise<CurrentAmpedProfileResponse> {
    const { data } = await brandApi.get('/amped/current');
    return data;
  }

  async saveProfile(payload: AmpedProfilePayload): Promise<AmpedProfile> {
    const { data } = await brandApi.post('/amped/profile', payload);
    return data.profile;
  }

  async subscribe(
    plan: 'STARTER' | 'PRO' | 'ELITE',
  ): Promise<{ success: boolean; confirmationUrl?: string }> {
    const { data } = await brandApi.post('/amped/subscribe', { plan });
    return data;
  }

  async cancel(): Promise<{
    success: boolean;
    confirmationUrl?: string;
    cancelledAmpedPlan?: 'STARTER' | 'PRO' | 'ELITE';
  }> {
    const { data } = await brandApi.post('/amped/cancel');
    return data;
  }
}

export const ampedService = AmpedService.getInstance();
